import {getPricingOption} from '@wix/wix-events-commons-statics'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useCurrencyFormatter} from '../../../../../../../../commons/hooks/currency'
import {getPlaceInfoForOrderSummary} from '../../../../../selectors/order-summary'
import {OrderedTicket} from '../../../../../types/state'
import {SummaryRow} from '../../summary-row'
import {GetPriceDetailsParams, PriceDetails, SeatTicketProps} from './interfaces'
import s from './seat-ticket.scss'

const getPriceDetails = ({ticket, priceOverride, pricingOptionId}: GetPriceDetailsParams): PriceDetails => {
  if (priceOverride) {
    return {price: Number(priceOverride)}
  }
  if (pricingOptionId) {
    const pricingOption = getPricingOption(ticket, pricingOptionId)
    return {price: Number(pricingOption.price.amount), pricingOptionName: pricingOption.name}
  }

  return {price: Number(ticket.price.amount)}
}

const getTicketName = (ticket: OrderedTicket, pricingOptionName?: string) =>
  pricingOptionName ? `${ticket.name} (${pricingOptionName})` : ticket.name

export const SeatTicket = ({ticket, seatId, seatIndex, seatingPlan, currency}: SeatTicketProps) => {
  const {t} = useTranslation()
  const priceOverride = ticket.seats.donations?.[seatIndex]
  const pricingOptionId = ticket.seats.pricingOptionIds?.[seatIndex]
  const {sectionTitle, elementTitle, area, table, place} = getPlaceInfoForOrderSummary(seatId, seatingPlan)
  const {getFormattedMoney} = useCurrencyFormatter()

  const {price, pricingOptionName} = getPriceDetails({ticket, priceOverride, pricingOptionId})

  return (
    <div className={s.container}>
      <SummaryRow
        label={getTicketName(ticket, pricingOptionName)}
        value={getFormattedMoney({amount: price.toString(), currency})}
      />
      <div className={s.seatDetails}>
        <SummaryRow label={t('seatings_sector')} value={sectionTitle} size="small" />
        {area ? (
          <SummaryRow label={t('seatings_area')} value={elementTitle} size="small" />
        ) : (
          <>
            <SummaryRow label={table ? t('seatings_table') : t('seatings_row')} value={elementTitle} size="small" />
            <SummaryRow label={t('seatings_seat')} value={place.label} size="small" />
          </>
        )}
      </div>
    </div>
  )
}
